import { render, staticRenderFns } from "./PaymentAdvertisement.vue?vue&type=template&id=05275d4a&"
import script from "./PaymentAdvertisement.vue?vue&type=script&lang=js&"
export * from "./PaymentAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports